export default "__VITE_ASSET__FZdYwoQV__"